export const agreementSections = [
  {
    content: [
      { text: '1. Informed Consent', bold: ['1. Informed Consent'] },
      {
        text: 'I, the Participant, am the age of majority in British Columbia, and I understand and agree that I am voluntarily participating in the use of the Gym services offered by the Company, and this is not a condition of my employment with the Company. Using the Gym includes but is not limited to use of the change rooms, the basketball court, the fitness room which includes but is not limited to treadmills, bicycles, weights, mats, exercise balls and other gym equipment (the “Activities”) conducted at 27426 60th Avenue, Langley, BC V4W 0B8.',
      },
      {
        text: 'If I bring a friend, family member, a minor or any other persons (the “Third-Party”) to use the Gym, I am responsible for the Third-Party while they occupy the Gym and/or engage in the Activities. I agree and understand that I am responsible for indemnifying the Company and its affiliates referred to as the Releasees, on behalf of the Third-Party, in accordance with Section 5(b) below.',
        italic: true,
        bold: ['I am responsible'],
      },
    ],
  },
  {
    content: [
      {
        text: '2. Assumption of Risk and Waiver of Liability',
        bold: ['2. Assumption of Risk and Waiver of Liability'],
      },
      {
        text: 'I, the Participant, understand and agree that I am voluntarily participating in the Activities and using the Gym. I acknowledge that I have been informed of the nature of the Activities and the Gym and I am aware of the risks associated with my participation in the Activities and using the Gym.',
      },
      {
        text: 'The Participant understands and acknowledges that occupying and/or using the Gym carries inherent risks, hazards and dangers, including but not limited to:',
      },
      {
        text: '(a) injuries such as sprains, muscle strains, falls, slipping if the surfaces are wet (i.e. sweat, water spills, wet shoes in the Gym);',
        listItem: true,
      },
      {
        text: '(b) Strenuous and demanding physical exertion, strenuous cardiovascular workouts, rapid movements, exertion, tension on various muscle groups which may cause serious injury to bones, ligaments, muscles, tendons or other aspects of the Participant’s body or the Participant’s general health and wellbeing;',
        listItem: true,
      },
      {
        text: '(c) concussion or other related head injuries including but not limited to closed head injury or blunt head trauma;',
        listItem: true,
      },
      {
        text: '(d) medical conditions, such as exacerbation of pre-existing medical conditions, heart attacks;',
        listItem: true,
      },
      {
        text: '(e) loss of property;',
        listItem: true,
      },
      {
        text: '(f) injuries resulting from misuse, improper use or failure of equipment, even if properly maintained;',
        listItem: true,
      },
      {
        text: '(g) accidents due to lack of supervision or assistance during exercise;',
        listItem: true,
      },
      {
        text: '(h) Potential exposure to infectious diseases, including but not limited to colds, flu, or COVID-19, due to shared equipment and communal areas; and',
        listItem: true,
      },
      {
        text: '(i) Any other risks not specifically listed but reasonably associated with the use of gym facilities.',
        listItem: true,
      },
      {
        text: 'The Participant acknowledges that there are both foreseeable and unforeseeable risks associated with the Activities and the Gym.',
      },
    ],
  },
  {
    content: [
      {
        text: '3. I, the Participant, understand and agree that:',
        bold: ['3.'],
      },
      {
        text: 'I. I am in good physical and mental condition to participate in the Activities;',
        listItem: true,
      },
      {
        text: 'II. I will comply with the rules and regulations for the Gym and the Activities;',
        listItem: true,
      },
      {
        text: 'III. If I observe a significant hazard or risk, I will remove myself from the Activities or the Gym and report the risk or hazards to the attention of the Company or their representative immediately.',
        listItem: true,
      },
      {
        text: 'IV. When I am using the gym or training in a section of the Gym, I am responsible for the surrounding and the location and equipment that I select',
        listItem: true,
      },
      {
        text: 'V. It is my responsibility to assess whether any Activities are too difficult for me and I acknowledge and accept the suitability and condition of the Activities; and',
        listItem: true,
      },
      {
        text: 'VI. I am responsible for my safety equipment, if required or recommended and the security fitting of the safety equipment',
        listItem: true,
      },
    ],
  },
  {
    content: [
      {
        text: '4. I HAVE SATISFIED MYSELF AND/OR WAIVED THE OPPORTUNITY TO OBTAIN INFORMATION NECESSARY TO MAKE AN INFORMED DECISION REGARDING THE CONSENT. I am aware that my involvement in the Activities or using the Gym will involve various risks, dangers and hazards including the risk of personal injury, death or property loss from various causes included but not limited to: defective and dangerous provisions of the Activities, unsafe conditions of the Gym, negligence on part of other persons in provision of the Activities or using the Gym or negligence on part of the Company, I freely accept and fully assume all risks, dangers, and hazards associated with my participation in the Activities in the Gym and the possibility of personal injury, death, property damage and loss resulting from this.',
        bold: [
          '4. I HAVE SATISFIED MYSELF AND/OR WAIVED THE OPPORTUNITY TO OBTAIN INFORMATION NECESSARY TO MAKE AN INFORMED DECISION REGARDING THE CONSENT.',
        ],
      },
    ],
  },
  {
    title: '5. RELEASE',
    content: [
      {
        text: 'In consideration of the provisions of the Activities and use of the Gym offered to me and for other good and valuable considerations, I agree as follows:',
      },
      {
        text: '(a) TO WAIVE ANY AND ALL CLAIMS that I have or may in the future have against the Company and to release the Releasees from any and all claims and liability (except as prevented by statute) for any injury including death, loss, damage, cost or relief of any kind due to any cause whatsoever, including: claims resulting from, arising out of the use of the Gym or in connection with the Activities offered by the Company including NEGLIGENCE; GROSS NEGLIGENCE; BREACH OF CONTRACT, VICARIOUS LIABILITY FOR ANY OTHER PERSON’S ACT OR OMISSION OR BREACH OF ANY STATUTORY OR OTHER DUTY OF CAR ON THE PART OF THE RELEASEES, INCLUDING ANY DUTY OF CARE OWED UNDER THE OCCUPIERS LIABILITY ACT, R.S. B.C 1996, C.337',
        bold: ['TO WAIVE ANY AND ALL CLAIMS'],
        listItem: true,
      },
      {
        text: '(b) I AGREE TO HOLD HARMLESS AND INDEMNIFY THE RELEASEES from any and all claims or liability for any damage to property of, or personal injury to, me or any Third Party resulting from the Third Party’s use or occupation of the Gym’s facilities or resulting from the Third Party participating in the Activities; and',
        bold: ['I AGREE TO HOLD HARMLESS AND INDEMNIFY THE RELEASEES'],
        listItem: true,
      },
      {
        text: '(c) I AGREE TO IMMEDIATELY notify the Company if any injury, accident, or incident occurs involving me or any Third Party during my use of the Gym, its facilities, or participation in the Activities and acknowledge that failure to notify the Company of any injury, accident, or incidents in a timely manner may cause me to incur additional liability.',
        bold: ['I AGREE TO IMMEDIATELY'],
        listItem: true,
      },
    ],
  },
  {
    content: [
      {
        text: '6. This Agreement shall be effective and binding upon my heirs, next of kin, executors, administrators, successors, assigns and representatives.',
      },
      {
        text: '7. If any portion of this Agreement is found to be unenforceable or invalid, that portion shall be severed from this Agreement and the remainder of this Agreement shall be construed as though the unenforceable portion had never been contained herein;',
      },
      {
        text: '8. In this Agreement, the masculine includes the feminine and the neutral genders and the plural includes the singular and vice versa.',
      },
      {
        text: '9. This Agreement shall be governed by and interpreted in accordance with the laws of the Province of British Columbia, and any litigation involving the parties to this Agreement shall be brought within the Province of British Columbia; and',
      },
      {
        text: '10. I understand that this Agreement represents the entire agreement between the Company and myself, the Participant, and it is binding.',
      },
      {
        text: '11. I will WAIVE AND GIVE UP IMPORTANT LEGAL RIGHTS which I or my heirs, next of kin, executors, administrators and assigns may have against the Releasees, including the right to sue. I have been afforded a full and unconstrained opportunity to withdraw from participating in the Activities or use of the Gym, should I not wish to assume all of the dangers and risks associated with it, but I have freely and voluntarily elected to assume all of these dangers and risks, to give up important legal rights as set out in this document, and to participate in the Activities. In entering into this Agreement, I am not relying upon any oral or written representations or statements of any kind made by the Releasees other than what is set forth in this Agreement.',
        italic: true,
        bold: ['WAIVE AND GIVE UP IMPORTANT LEGAL RIGHTS'],
      },
    ],
    specialInitial: true,
  },
  {
    content: [
      {
        text: '12. Code of Conduct and Safety Regulations',
        bold: ['12. Code of Conduct and Safety Regulations'],
      },
      {
        text: 'The Participant agrees to:',
      },
      {
        text: '• Follow all the Gym rules and posted safety guidelines posted in and around the Gym.',
        listItem: true,
      },
      {
        text: '• Use the Gym equipment responsibly and report any malfunctions immediately.',
        listItem: true,
      },
      {
        text: '• Wear the appropriate athletic attire and footwear and safety equipment.',
        listItem: true,
      },
      {
        text: '• Respect other users in the Gym and maintain cleanliness.',
        listItem: true,
      },
      {
        text: '• No unauthorized guests are welcome in the Gym.',
        listItem: true,
      },
      {
        text: '13. Personal Property',
        bold: ['13. Personal Property'],
      },
      {
        text: 'The Participant understands that the Company is not responsible for lost, stolen, or damaged personal items brought into the Gym. The Participant should secure their belongings in lockers or designated storage areas.',
      },
      {
        text: '14. CCTV Surveillance',
        bold: ['14. CCTV Surveillance'],
      },
      {
        text: 'To enhance security and safety, the Gym is monitored by CCTV cameras. The Company retains the right to review footage for security and operational purposes. CCTV footage will be stored securely and accessed only by authorized personnel in accordance with privacy laws. (See Appendix A for the full CCTV policy.)',
      },
      {
        text: '15. The Participant’s Acknowledgment and Signature',
        bold: ['15. The Participant’s Acknowledgment and Signature'],
      },
      {
        text: 'I have read, understood, and voluntarily agree to the terms of this Agreement. I acknowledge that I have had the opportunity to ask questions before signing.',
      },
    ],
    lastPage: true,
  },
];
